var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function createMappedUpdateMutationOption(queryKey, queryClient, mapper, dependantQueryKeys) {
    return {
        onMutate: function (updatedResource) {
            return __awaiter(this, void 0, void 0, function () {
                var previousResources, updater;
                return __generator(this, function (_a) {
                    previousResources = queryClient.getQueryData(queryKey);
                    updater = getMappedCachedArrayResourceUpdater(updatedResource, mapper);
                    queryClient.setQueryData(queryKey, updater);
                    return [2 /*return*/, { previousResources: previousResources }];
                });
            });
        },
        onError: function (error, variables, context) {
            console.error('Failed to update mapped resource: ', variables, ' queryKey=', queryKey);
            queryClient.setQueryData(queryKey, context === null || context === void 0 ? void 0 : context.previousResources);
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dependantQueryKeys_1, dependantQueryKeys_1_1, qk, e_1_1;
                var e_1, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _b.sent();
                            if (!dependantQueryKeys) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 7, 8, 9]);
                            dependantQueryKeys_1 = __values(dependantQueryKeys), dependantQueryKeys_1_1 = dependantQueryKeys_1.next();
                            _b.label = 3;
                        case 3:
                            if (!!dependantQueryKeys_1_1.done) return [3 /*break*/, 6];
                            qk = dependantQueryKeys_1_1.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(qk)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            dependantQueryKeys_1_1 = dependantQueryKeys_1.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = { error: e_1_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (dependantQueryKeys_1_1 && !dependantQueryKeys_1_1.done && (_a = dependantQueryKeys_1.return)) _a.call(dependantQueryKeys_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
function createUpdateMutationOptions(queryKey, queryClient, dependantQueryKeys) {
    return {
        onMutate: function (updatedResource) {
            return __awaiter(this, void 0, void 0, function () {
                var previousResources, updater;
                return __generator(this, function (_a) {
                    previousResources = queryClient.getQueryData(queryKey);
                    updater = getCachedArrayResourceUpdater(updatedResource);
                    queryClient.setQueryData(queryKey, updater);
                    return [2 /*return*/, { previousResources: previousResources }];
                });
            });
        },
        onError: function (error, variables, context) {
            console.error('Failed to update resource: ', variables, ' queryKey=', queryKey);
            queryClient.setQueryData(queryKey, context === null || context === void 0 ? void 0 : context.previousResources);
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dependantQueryKeys_2, dependantQueryKeys_2_1, qk, e_2_1;
                var e_2, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _b.sent();
                            if (!dependantQueryKeys) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 7, 8, 9]);
                            dependantQueryKeys_2 = __values(dependantQueryKeys), dependantQueryKeys_2_1 = dependantQueryKeys_2.next();
                            _b.label = 3;
                        case 3:
                            if (!!dependantQueryKeys_2_1.done) return [3 /*break*/, 6];
                            qk = dependantQueryKeys_2_1.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(qk)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            dependantQueryKeys_2_1 = dependantQueryKeys_2.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_2_1 = _b.sent();
                            e_2 = { error: e_2_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (dependantQueryKeys_2_1 && !dependantQueryKeys_2_1.done && (_a = dependantQueryKeys_2.return)) _a.call(dependantQueryKeys_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
function createInvalidateMutationOptions(queryKey, queryClient, dependantQueryKeys) {
    return {
        onMutate: function (resourceId) {
            return __awaiter(this, void 0, void 0, function () {
                var previousResources, updater;
                return __generator(this, function (_a) {
                    previousResources = queryClient.getQueryData(queryKey);
                    updater = Array.isArray(resourceId)
                        ? getCachedArrayMultipleResourceRemover(resourceId)
                        : getCachedArrayResourceRemover(resourceId);
                    queryClient.setQueryData(queryKey, updater);
                    return [2 /*return*/, { previousResources: previousResources }];
                });
            });
        },
        onError: function (error, resourceId, context) {
            console.error('Failed to delete resource id=', resourceId, ' queryKey=', queryKey);
            queryClient.setQueryData(queryKey, context === null || context === void 0 ? void 0 : context.previousResources);
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dependantQueryKeys_3, dependantQueryKeys_3_1, qk, e_3_1;
                var e_3, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _b.sent();
                            if (!dependantQueryKeys) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 7, 8, 9]);
                            dependantQueryKeys_3 = __values(dependantQueryKeys), dependantQueryKeys_3_1 = dependantQueryKeys_3.next();
                            _b.label = 3;
                        case 3:
                            if (!!dependantQueryKeys_3_1.done) return [3 /*break*/, 6];
                            qk = dependantQueryKeys_3_1.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(qk)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            dependantQueryKeys_3_1 = dependantQueryKeys_3.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_3_1 = _b.sent();
                            e_3 = { error: e_3_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (dependantQueryKeys_3_1 && !dependantQueryKeys_3_1.done && (_a = dependantQueryKeys_3.return)) _a.call(dependantQueryKeys_3);
                            }
                            finally { if (e_3) throw e_3.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
function createCreateMutationOptions(queryKey, queryClient, dependantQueryKeys) {
    return {
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dependantQueryKeys_4, dependantQueryKeys_4_1, qk, e_4_1;
                var e_4, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _b.sent();
                            if (!dependantQueryKeys) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 7, 8, 9]);
                            dependantQueryKeys_4 = __values(dependantQueryKeys), dependantQueryKeys_4_1 = dependantQueryKeys_4.next();
                            _b.label = 3;
                        case 3:
                            if (!!dependantQueryKeys_4_1.done) return [3 /*break*/, 6];
                            qk = dependantQueryKeys_4_1.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(qk)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            dependantQueryKeys_4_1 = dependantQueryKeys_4.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_4_1 = _b.sent();
                            e_4 = { error: e_4_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (dependantQueryKeys_4_1 && !dependantQueryKeys_4_1.done && (_a = dependantQueryKeys_4.return)) _a.call(dependantQueryKeys_4);
                            }
                            finally { if (e_4) throw e_4.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
var mutationOptionsMap = {
    update: createUpdateMutationOptions,
    delete: createInvalidateMutationOptions,
    create: createCreateMutationOptions,
    invalidate: createInvalidateMutationOptions,
};
var mutationOptionsWithMappersMap = {
    update: createMappedUpdateMutationOption,
};
var MutationOptionsFactory = /** @class */ (function () {
    function MutationOptionsFactory() {
    }
    MutationOptionsFactory.prototype.create = function (type, queryKey, queryClient, dependantQueryKeys) {
        return mutationOptionsMap[type](queryKey, queryClient, dependantQueryKeys);
    };
    MutationOptionsFactory.prototype.createWithMapper = function (type, queryKey, queryClient, mapper, dependantQueryKeys) {
        return mutationOptionsWithMappersMap[type](queryKey, queryClient, mapper, dependantQueryKeys);
    };
    return MutationOptionsFactory;
}());
var mutationOptionsFactory = new MutationOptionsFactory();
export function getMutationOptionsFactory() {
    return mutationOptionsFactory;
}
export function getCachedArrayResourceUpdater(updatedResource) {
    return function (oldResources) {
        if (oldResources === undefined) {
            return undefined;
        }
        return oldResources.map(function (oldItem) {
            if (oldItem.id === updatedResource.id) {
                return __assign(__assign({}, oldItem), updatedResource);
            }
            return oldItem;
        });
    };
}
export function getMappedCachedArrayResourceUpdater(updatedMappedResource, mapper) {
    return function (oldResources) {
        if (!oldResources) {
            return undefined;
        }
        return oldResources.map(function (item) {
            if (item.id === updatedMappedResource.id) {
                return mapper(updatedMappedResource);
            }
            return item;
        });
    };
}
export function getCachedArrayResourceRemover(resourceId) {
    return function (oldResource) {
        if (!oldResource) {
            return;
        }
        return oldResource.filter(function (c) { return resourceId !== c.id; });
    };
}
export function getCachedArrayMultipleResourceRemover(resourceIds) {
    return function (oldResource) {
        if (!oldResource) {
            return;
        }
        return oldResource.filter(function (c) { return !resourceIds.includes(c.id); });
    };
}
export function addQueryClientItem(queryClient, queryKey, newItem) {
    queryClient.setQueryData(__spreadArray(__spreadArray([], __read(queryKey), false), [newItem.id], false), newItem);
    addQueryClientArrayMember(queryClient, queryKey, newItem);
}
export function addQueryClientArrayMember(queryClient, queryKey, newMember) {
    queryClient.setQueryData(queryKey, function (oldMembers) {
        if (oldMembers) {
            return __spreadArray(__spreadArray([], __read(oldMembers), false), [newMember], false);
        }
        else {
            return [newMember];
        }
    });
}
export function addMultipleQueryClientArrayMembers(queryClient, queryKey, newMembers) {
    queryClient.setQueriesData(queryKey, function (oldMembers) {
        if (oldMembers) {
            return __spreadArray(__spreadArray([], __read(oldMembers), false), __read(newMembers), false);
        }
        else {
            return newMembers;
        }
    });
}
export function updateQueryClientItem(queryClient, queryKey, updatedItem) {
    queryClient.cancelQueries(__spreadArray(__spreadArray([], __read(queryKey), false), [updatedItem.id], false));
    queryClient.setQueryData(__spreadArray(__spreadArray([], __read(queryKey), false), [updatedItem.id], false), updatedItem);
    updateQueryClientArrayMember(queryClient, queryKey, updatedItem);
}
export function updateQueryClientArrayMember(queryClient, queryKey, updatedMember) {
    queryClient.cancelQueries(queryKey);
    queryClient.setQueryData(queryKey, function (oldMembers) {
        if (oldMembers) {
            var index = oldMembers.findIndex(function (u) { return u.id === updatedMember.id; });
            if (index === -1) {
                return __spreadArray(__spreadArray([], __read(oldMembers), false), [updatedMember], false);
            }
            else {
                var newMembers = __spreadArray([], __read(oldMembers), false);
                newMembers[index] = updatedMember;
                return newMembers;
            }
        }
        else {
            return [updatedMember];
        }
    });
}
export function updateMultipleQueryClientArrayMembers(queryClient, queryKey, updatedMembers) {
    queryClient.setQueriesData(queryKey, function (oldMembers) {
        if (oldMembers) {
            var newMembers_1 = __spreadArray([], __read(oldMembers), false);
            updatedMembers.forEach(function (um) {
                var index = oldMembers.findIndex(function (u) { return u.id === um.id; });
                if (index === -1) {
                    newMembers_1.push(um);
                }
                else {
                    newMembers_1[index] = um;
                }
            });
            return newMembers_1;
        }
        else {
            return __spreadArray([], __read(updatedMembers), false);
        }
    });
}
export function removeQueryClientItem(queryClient, queryKey, itemId) {
    queryClient.removeQueries(__spreadArray(__spreadArray([], __read(queryKey), false), [itemId], false));
    removeQueryClientArrayMember(queryClient, queryKey, itemId);
}
export function removeQueryClientArrayMember(queryClient, queryKey, memberId) {
    queryClient.setQueryData(queryKey, function (oldMembers) {
        if (oldMembers) {
            return oldMembers.filter(function (m) { return m.id !== memberId; });
        }
        else {
            return [];
        }
    });
}
export function removeMultipleQueryClientArrayMembers(queryClient, queryKey, memberIds) {
    queryClient.setQueriesData(queryKey, function (oldMembers) {
        if (oldMembers) {
            return oldMembers.filter(function (m) { return !memberIds.includes(m.id); });
        }
        else {
            return [];
        }
    });
}
